import { Address, Identity } from '@/classes/models'

export default class Customer {
  /**
   * Create new customer and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map billing identity to Identity
    if (typeof this.billingIdentity !== 'undefined') {
      this.billingIdentity = new Identity(this.billingIdentity)
    }

    // Map billing identity to Identity
    if (typeof this.billingAddress !== 'undefined') {
      this.billingAddress = new Address(this.billingAddress)
    }

    // Map billing identity to Identity
    if (typeof this.shippingAddress !== 'undefined') {
      this.shippingAddress = new Address(this.shippingAddress)
    }
  }

  /**
   * @return {string|null}
   */
  get salutation () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.title
  }

  /**
   * @return {string|null}
   */
  get fullName () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.fullName
  }

  /**
   * @return {string|null}
   */
  get emailAddress () {
    if (!this.billingIdentity) {
      return null
    }

    return this.billingIdentity.emailAddress
  }

  /**
   * @return {string|null}
   */
  get telephoneNumber () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.phoneNumber1
  }

  /**
   * @return {string|null}
   */
  get telephoneNumberAdditional () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.phoneNumber2
  }

  get address () {
    if (!this.billingAddress) {
      return null
    }

    return [this.billingAddress.addressLine1, this.billingAddress.addressLine2].filter(Boolean).join(', ')
  }

  /**
   * @return {string|null}
   */
  get addressLine () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.addressLine1
  }

  /**
   * @return {string|null}
   */
  get addressLineAdditional () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.addressLine2
  }

  /**
   * @return {string|null}
   */
  get zipCode () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.zipCode
  }

  /**
   * @return {string|null}
   */
  get city () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.city
  }

  /**
   * @return {string|null}
   */
  get country () {
    if (!this.billingAddress) {
      return null
    }

    return this.billingAddress.countryIso3166Alpha2
  }

  /**
   * @return {string|null}
   */
  get organisation () {
    if (!this.billingAddress) {
      return null
    }

    return [this.billingAddress.organisation, this.billingAddress.department].filter(Boolean).join(', ')
  }
}
